const waitForController = (): Promise<void> => {
	if (navigator.serviceWorker.controller) return Promise.resolve();

	return new Promise((resolve) => {
		navigator.serviceWorker.addEventListener(
			'controllerchange',
			() => resolve(),
			{ once: true },
		);
	});
};

export const registerServiceWorker = async (): Promise<ServiceWorkerRegistration | null> => {
	if (!('serviceWorker' in navigator)) {
		console.warn('Service workers are not supported in this browser');
		return null;
	}

	try {
		await navigator.serviceWorker.register('serviceWorker.js');
		const registration = await navigator.serviceWorker.ready;
		await waitForController();
		return registration;
	} catch (error) {
		console.error('Service Worker Registration FAILED:', error);
		return null;
	}
};


